type AdaptiveCardActivity = {
  value?: {
    actionId?: string
  }
}

export const dismissOnSubmitActionIds = [
  'submit-date',
  'submit-idvt',
  'open-banking-submit',
  'open-banking-help',
  'payroll-submit',
  'payroll-help',
  'select-connection',
  'select-account',
  'none-of-these',
  'previous-opt-out',
  'change-answer',
  'confirm-match',
]

export const shouldDismissAdaptiveCard = (
  activity: AdaptiveCardActivity | null | undefined,
): boolean => {
  const actionId = activity?.value?.actionId

  return actionId !== undefined && dismissOnSubmitActionIds.includes(actionId)
}
